export const ROLES = {
  organization: 'organizations',
  certificate: 'certificate',
  department: 'department',
  operator: 'operators',
  member: 'member',
  expert: 'expert',
  admin: 'admins',
  trainer: 'trainer',
  moderator: 'moderator',
  event_manager: 'event_manager',
  guest: 'guest',
};

export const ROLES_NAMES = {
  [ROLES.organization]: 'Организация',
  [ROLES.certificate]: 'Сертификат',
  [ROLES.department]: 'Департамент',
  [ROLES.operator]: 'Оператор',
  [ROLES.member]: 'Участник',
  [ROLES.expert]: 'Эксперт',
  [ROLES.admin]: 'Администратор',
  [ROLES.trainer]: 'Наставник',
  [ROLES.moderator]: 'Модератор',
  [ROLES.event_manager]: 'Event-менеджер',
  [ROLES.guest]: 'Гость',
};

export const ROLES_DATA = {
  [ROLES.organization]: {
    id: 1,
    name: ROLES.organization,
  },
  [ROLES.guest]: {
    id: 666,
    name: ROLES.guest,
  },
};
